import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import { createApiClient } from '../../apiClient';

/**
 * Retrieves the current MFA recovery codes for the user.
 *
 * This function fetches the backup codes that can be used to bypass
 * MFA requirements if none of the registered MFA methods are available.
 * If user doesn't have any recovery codes, it will create them,
 * otherwise it will return the existing ones.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves to the user's MFA recovery codes.
 */
export const getMfaRecoveryCodes = async (client = getDefaultClient()) => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  return apiClient.getRecoveryCodes({
    environmentId: core.environmentId,
  });
};
